import { render, staticRenderFns } from "./CustomTableModal.vue?vue&type=template&id=fec20a6a"
import script from "./CustomTableModal.vue?vue&type=script&lang=js"
export * from "./CustomTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports